import styled from "styled-components"
import { mobilePortrait, mobile, tabletPortrait, tablet, smallScreen } from "../../Responsive"

export const Container = styled.div`
    height: 100vh;
    display: flex;
    scroll-snap-align: center;
    position: relative;
    overflow: hidden;
    padding: 100px 20px 20px 20px;
    z-index: 0;

    ${tablet({ padding: "80px 10px 10px 10px" })}
    ${mobile({ paddingTop: "40px" })}
    ${tabletPortrait({ flexDirection: "column" })}
`

export const Wrapper = styled.div`
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    z-index: 3;

    ${tabletPortrait({ width: "100%", height: "50%" })}
`

export const Image = styled.img`
    width: 50%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 10px;
    z-index: 1;

    ${tabletPortrait({ width: "100%", height: "50%" })}
`

export const Title = styled.h1`
    color: var(--darkGrey);
    margin: 0;

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontL);
    }
`

export const Text = styled.p`
    color: var(--darkGrey);
    margin-top: 1rem;
    width: 70%;
    max-width: 800px;

    ${mobilePortrait({ width: "90%" })}
`